const id_purch_returnsupplier = {
    "": "retur pemasok",
    type: "metode retur",

    label: {
        ref_itemin: "referensi barang masuk",
        no_trans_in: "nomor transaksi barang masuk",
    },

    error: {
        create: "Gagal membuat retur pemasok.",
        edit: "Gagal mengubah retur pemasok.",
        type: "Jenis retur tidak boleh kosong.",
        sn_not_found: "Barang dengan serial number: {{sn}} masih berada di gudang atau belum terdaftar.",
    },

    success: {
        create: "Berhasil membuat retur pemasok.",
        edit: "Berhasil mengubah retur pemasok.",
    },
}

export default id_purch_returnsupplier;